// src/components/providers/providers.tsx
'use client';

import { ReactNode } from 'react';
import QueryProvider from '@/components/providers/query.providers';

interface ProvidersProps {
  children: ReactNode;
}

export default function Providers({ children }: ProvidersProps) {
  return <QueryProvider>{children}</QueryProvider>;
}
